import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';
import { ReviewCard } from '../components/ReviewCard';
import { FAQAccordion } from '../components/FAQAccordion';
import { CTABand } from '../components/CTABand';
export function MiniTroopers() {
  useEffect(() => {
    document.title = 'Mini Troopers (Ages 3-5) | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-612">
      {/* Hero */}
      <section className="relative bg-ink pt-16 pb-24 overflow-hidden" data-id="element-613">
        <div className="absolute inset-0 opacity-30" data-id="element-614">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.stormtaekwondo.com/uploaded/images/Redesigne%202024/Mini-Troopers-Storm-Taekwondo.jpg" alt="Kids Martial Arts" className="w-full h-full object-cover" data-id="element-615" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-616" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-617">
          <div className="max-w-2xl" data-id="element-618">
            <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-619">
              Ages 3-5
            </div>
            <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-620">
              Mini Troopers: Big Skills for Little Learners
            </h1>
            <p className="text-xl text-off-white mb-8 leading-relaxed" data-id="element-621">
              A fun, structured martial arts program designed specifically for
              preschoolers. We help active kids build focus, coordination, and
              listening skills in a positive environment.
            </p>
            <Link to="/free-trial" className="btn-primary" data-id="element-622">
              Claim Your Free Week
            </Link>
          </div>
        </div>
      </section>

      {/* What They Learn */}
      <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-623">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-624">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-625">
            <div data-id="element-626">
              <h2 className="text-4xl text-ink mb-8" data-id="element-627">
                Building a Foundation for Success
              </h2>
              <p className="text-lg text-gray-warm mb-8" data-id="element-628">
                Our Mini Troopers class isn't just about kicking and punching.
                It's about teaching young children how to learn, how to interact
                with others, and how to control their bodies.
              </p>
              <ul className="flex flex-col gap-4" data-id="element-629">
                {['Listening and following directions', 'Focus and attention span', 'Balance and body coordination', 'Respect for teachers and peers', 'Sharing and taking turns on the mat', 'Stranger awareness and basic safety'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-lg text-ink font-medium" data-id="element-630">
                    <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0 mt-0.5" data-id="element-631" />
                    <span data-id="element-632">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-633">
              <h3 className="text-2xl text-ink mb-4" data-id="element-634">Class Schedule</h3>
              <div className="flex items-center justify-between p-4 bg-paper rounded-xl border border-subtle-gray mb-4" data-id="element-635">
                <span className="font-bold text-ink" data-id="element-636">Monday – Friday</span>
                <span className="bg-subtle-gray/50 px-3 py-1 rounded-lg text-ink font-bold" data-id="element-637">
                  4:30 PM – 5:00 PM
                </span>
              </div>
              <p className="text-sm text-gray-warm text-center" data-id="element-638">
                Classes are 30 minutes long - the perfect duration for preschool
                attention spans.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews */}
      <section className="py-24 bg-off-white" data-id="element-639">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-640">
          <h2 className="text-4xl text-ink text-center mb-16" data-id="element-641">
            Parents Love Mini Troopers
          </h2>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-642">
            <ReviewCard quote="My 4-year-old had trouble focusing, but after a few months in Mini Troopers, his preschool teacher noticed a huge difference in his listening skills." name="Amanda T." label="Parent Review" data-id="element-643" />
            <ReviewCard quote="The coaches are incredibly patient and know exactly how to keep the little ones engaged. It's the highlight of my daughter's week." name="Marcus W." label="Parent Review" data-id="element-644" />
            <ReviewCard quote="A perfect introduction to martial arts. They learn real skills but in a way that feels like a fun game." name="Jessica H." label="Parent Review" data-id="element-645" />
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-646">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-647">
          <h2 className="text-4xl text-ink text-center mb-16" data-id="element-648">
            Common Questions
          </h2>
          <FAQAccordion faqs={[{
          question: 'Is 3 years old too young to start?',
          answer: 'Not at all! Our Mini Troopers curriculum is specifically designed for the developmental stage of 3 to 5-year-olds. We focus on gross motor skills and basic listening.'
        }, {
          question: 'Do parents participate in the class?',
          answer: 'Parents watch from our comfortable viewing area. This helps children learn independence and how to take instruction directly from our coaches.'
        }, {
          question: 'What should my child wear for the trial?',
          answer: 'Comfortable play clothes or athletic wear (like sweatpants and a t-shirt) are perfect for the first week.'
        }]} data-id="element-649" />
        </div>
      </section>

      <CTABand headline="Ready for Your Child's First Class?" copy="Claim a free week of Mini Troopers and see how martial arts can help your preschooler thrive." data-id="element-650" />
    </div>;
}